import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomAutocomplete from "./CustomAutocomplete";
import CustomSelect from "./CustomSelect";

import {
  getAllVehiculosServicioPesado,
  getModelos,
  getFamilias,
  getProductos,
} from "../repository";

const SearchByHeavyService = ({actualizarproductos}) => {
  const [, setStatus] = useState(null);
  const [idVehiculo, setIdVehiculo] = useState(0);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);
  const [idModelo, setIdModelo] = useState(0);
  const [idFamilia, setIdFamilia] = useState(-1);
  const [vehiculosServPesado, setVehiculos] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [, setProductos] = useState([]);
  const [loading, setLoading] = useState(0);
  const [errors, setErrors] = useState({});

  // Toast configuration
  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  useEffect(() => {
    obtieneVehiculos();
  }, []);

  const obtieneVehiculos = () => {
    getAllVehiculosServicioPesado()
      .then((response) => {
        if (response.status === "success") {
          setVehiculos(response.result);
        } else {
          Swal.fire({
            text: "Error al obtener la información de vehículos.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de vehículos.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const handleVehiculoChange = (e) => {
    setVehiculoSeleccionado(e.value);
    setErrors({});
    if (!e.value || typeof e.value === "string") {
      setIdVehiculo(0);
      setIdModelo(0);
      setModelos([]);
      setIdFamilia(-1);
      setFamilias([]);
      setProductos([]);
      actualizarproductos([]);
      setStatus(null);
    }
  };

  const handleVehiculoSelect = (e) => {
    const selected = e.value;
    setIdVehiculo(selected.key);
    setVehiculoSeleccionado(selected);
    setIdModelo(0);
    setModelos([]);
    setIdFamilia(-1);
    setFamilias([]);
    setProductos([]);
    actualizarproductos([]);
    setStatus(null);
    setErrors({});
    obtieneModelos(selected.key);
  };

  // Handler para Modelo
  const handleModeloChange = (selectedValue) => {
    actualizarproductos([]);
    setErrors({});
    setIdFamilia(-1);
    setFamilias([]);
    setProductos([]);
    setStatus(null);
    setIdModelo(selectedValue);
    if (selectedValue && selectedValue !== 0 && selectedValue !== "0") {
      obtieneFamilias(idVehiculo, selectedValue);
    }
  };

  // Handler para Familia
  const handleFamiliaChange = (selectedValue) => {
    const value = parseInt(selectedValue);
    actualizarproductos([]);
    setErrors({});
    setIdFamilia(value);
    setProductos([]);
    setStatus(null);
  };

  const obtieneModelos = (idVehiculo) => {
    getModelos(idVehiculo)
      .then((response) => {
        if (response.status === "success") {
          var items = response.result.map((item) => {
            return { value: item.Modelo, text: item.Modelo };
          });
          setModelos([{ value: 0, text: items.length > 0 ? "Seleccione" : "---" }].concat(items));
        } else {
          Swal.fire({
            text: "Error al obtener la información de modelos.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de modelos.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const obtieneFamilias = (idVehiculo, idModelo) => {
    getFamilias(idVehiculo, idModelo)
      .then((response) => {
        if (response.status === "success") {
          var items = [];
          if (idVehiculo > 0 && idModelo && idModelo !== "0") {
            items = response.result.map((item) => {
              return { value: item.idFamilia, text: item.Familia };
            });
          }
          setFamilias([{ value: -1, text: items.length > 0 ? "Seleccione" : "---" }].concat(items));
        } else {
          Swal.fire({
            text: "Error al obtener la información de familias.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de familias.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  //Search Products
  const search = (e) => {
    e.preventDefault();
    setProductos([]);
    actualizarproductos([]);
    setStatus(null);

    // Validación de campos requeridos
    const newErrors = {};
    if (!idVehiculo || idVehiculo === 0) newErrors.idVehiculo = true;
    if (!idModelo || idModelo === 0 || idModelo === "0") newErrors.idModelo = true;
    if (idFamilia === -1 || idFamilia === null || idFamilia === undefined) newErrors.idFamilia = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      Toast.fire({
        icon: "warning",
        text: "Selecciona todas las opciones",
      });
      return;
    }

    setLoading(1);
    setErrors({});

    getProductos(idVehiculo, idFamilia, idModelo)
      .then((response) => {
        if (response.status === "success") {
          setStatus("success");
          setProductos(response.result);
          actualizarproductos(response.result);
          setLoading(0);
        } else {
          setLoading(0);
          Swal.fire({
            text: "Error al obtener la información.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() => {
        setLoading(0);
        Swal.fire({
          text: "Error al obtener la información.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        });
      });
  };

  return (
    <div className="mt-1">
      <form onSubmit={search}>
        <div className="container">
          <div className="row align-items-end">
            <div className="col-12 col-sm-6 col-md mb-2">
              <h6>Vehículo:</h6>
              <CustomAutocomplete
                name="idVehiculo"
                value={vehiculoSeleccionado}
                options={vehiculosServPesado}
                field="value"
                onChange={handleVehiculoChange}
                onSelect={handleVehiculoSelect}
                placeholder="Capture el Vehículo"
                hasError={errors.idVehiculo}
              />
            </div>
            <div className="col-12 col-sm-6 col-md mb-2">
              <h6>Modelo:</h6>
              <CustomSelect
                name="idModelo"
                value={idModelo}
                options={modelos}
                onChange={handleModeloChange}
                placeholder="Seleccione"
                disabled={!idVehiculo || idVehiculo === 0}
                hasError={errors.idModelo}
              />
            </div>
            <div className="col-12 col-sm-6 col-md mb-2">
              <h6>Familia:</h6>
              <CustomSelect
                name="idFamilia"
                value={idFamilia}
                options={familias}
                onChange={handleFamiliaChange}
                placeholder="Seleccione"
                disabled={!idModelo || idModelo === 0 || idModelo === "0"}
                hasError={errors.idFamilia}
              />
            </div>
            <div className="col-12 col-sm-6 col-md-auto mb-2 mt-3 mt-sm-0">
              <button className="btn btn-secondary w-100" type="submit">
                <i className="fa fa-search mr-1"></i>Buscar
              </button>
            </div>
          </div>
          {loading === 1 && (
            <div className="text-center mb-3 mt-3">
              <h6>Buscando...</h6>
              <div
                className="spinner-border text-warning"
                role="status"
                aria-hidden="true"
              ></div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default SearchByHeavyService;
